import request from "@/util/http"; // 建议列表查询

export var getAdvicePage = function getAdvicePage(params) {
  return request({
    url: "/admin/advice/page",
    method: "get",
    params: params
  });
}; // 删除建议

export var handleAdviceDelete = function handleAdviceDelete(id) {
  return request({
    url: "/admin/advice/delete/".concat(id),
    method: "delete"
  });
}; // 建议详情

export var getAdviceInfo = function getAdviceInfo(id) {
  return request({
    url: "/admin/advice/get/".concat(id),
    method: "get"
  });
}; // 新增建议

export var adviceAdd = function adviceAdd(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/advice/save",
    method: "post",
    data: JSON.stringify(data)
  });
}; // 回复建议

export var adviceEdit = function adviceEdit(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/advice/update",
    method: "post",
    data: JSON.stringify(data)
  });
}; //--------------------------------------------------------------------------
// 留言列表查询

export var getServeLeaveMessagePage = function getServeLeaveMessagePage(params) {
  return request({
    url: "/admin/serveLeaveMessage/page",
    method: "get",
    params: params
  });
}; // 删除留言

export var handleServeLeaveMessageDelete = function handleServeLeaveMessageDelete(id) {
  return request({
    url: "/admin/serveLeaveMessage/delete/".concat(id),
    method: "delete"
  });
}; // 留言详情

export var getServeLeaveMessageInfo = function getServeLeaveMessageInfo(id) {
  return request({
    url: "/admin/serveLeaveMessage/get/".concat(id),
    method: "get"
  });
}; // 新增或者修改留言

export var serveLeaveMessageAddAndEdit = function serveLeaveMessageAddAndEdit(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/serveLeaveMessage/saveOrUpdate",
    method: "post",
    data: JSON.stringify(data)
  });
}; //--------------------------------------------------------------------------
// 删除留言回复

export var handleMessageAnswerDelete = function handleMessageAnswerDelete(id) {
  return request({
    url: "/admin/messageAnswer/delete/".concat(id),
    method: "delete"
  });
}; //新增或者修改留言回复

export var messageAnswerAddAndEdit = function messageAnswerAddAndEdit(data) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/messageAnswer/save",
    method: "post",
    data: JSON.stringify(data)
  });
};